import { API_BASE_URL } from "../config/api";

export const accessoryService = {
  // CREATE
  createAccessory: async (formData) => {
    console.log("formData",formData);
    const res = await fetch(`${API_BASE_URL}/accessories`, {
      method: "POST",
      body: formData, // let browser set headers
    });

    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.message || "Failed to create accessory");
    }

    return res.json();
  },

  // GET BY PRODUCT
  getAccessoriesByProduct: async (productId) => {
    const res = await fetch(
      `${API_BASE_URL}/accessories/product/${productId}`
    );

    if (!res.ok) {
      throw new Error("Failed to fetch accessories");
    }

    return res.json();
  },

  // DELETE (optional)
  deleteAccessory: async (id) => {
    const res = await fetch(`${API_BASE_URL}/accessories/${id}`, {
      method: "DELETE",
    });

    if (!res.ok) {
      throw new Error("Failed to delete accessory");
    }

    return res.json();
  },
};
